
'use strict';

// import cf7Helpers from '../../../src/js/shared/cf7Helpers';

const $ = jQuery.noConflict();
$(function() {

	const basicBlock = {

		init: function() {
			// cf7Helpers.afterFormSubmit();
		},

	};

	basicBlock.init();
});
